import { jsx as _jsx } from "react/jsx-runtime";
import { MultiSelect } from "primereact/multiselect";
import React, { useMemo } from "react";
export const RoleMultiSelect = ({ rolesList, value, onChange, placeholder = "Select roles", disabled, className = "", }) => {
    const options = useMemo(() => rolesList.roles.map((r) => ({
        label: r.name,
        value: r.id,
    })), [rolesList.roles]);
    const label = useMemo(() => {
        if (!value.length)
            return placeholder;
        return `${value.length} role${value.length !== 1 ? "s" : ""} selected`;
    }, [value.length, placeholder]);
    const handleChange = (e) => {
        onChange(e.value || []);
    };
    return (_jsx("div", { className: "psp-treeselect-holder", children: _jsx(MultiSelect, { className: `w-full psp-treeselect-compact ${className}`, value: value, onChange: handleChange, options: options, placeholder: placeholder, disabled: disabled, filter: true, filterPlaceholder: "Search roles", display: "chip", showClear: true, "aria-label": "Role multi-select" }) }));
};
